import { App, nextTick } from 'vue';
import { useDeviceDetection } from '@/common/composables/useDeviceDetection';

import { logger } from '@/common/services/config';
export default {
  install(app: App) {
    // Plugin simplifié - la logique de détection est maintenant dans useDeviceDetection
    // Ce plugin ne fait plus que fournir des utilitaires CSS optionnels

    // Fonction utilitaire pour ajouter des classes CSS au body
    const updateBodyClasses = () => {
      try {
        // Import statique pour éviter les conflits de chunking
        const detection = useDeviceDetection();
        const body = document.body;

        // Nettoyer les classes existantes
        body.classList.remove('device-mobile', 'device-tablet', 'device-desktop');
        body.classList.remove('orientation-portrait', 'orientation-landscape');
        body.classList.remove('touch-device', 'no-touch');

        // Ajouter les nouvelles classes
        body.classList.add(`device-${detection.deviceType.value}`);
        body.classList.add(
          detection.isPortrait.value ? 'orientation-portrait' : 'orientation-landscape'
        );
        body.classList.add(detection.isTouchDevice.value ? 'touch-device' : 'no-touch');
      } catch (error) {
        logger.warn('Could not update body classes:', error);
      }
    };

    // Mettre à jour les classes après l'initialisation de l'app
    nextTick(() => {
      updateBodyClasses();
    });

    // Écouter les changements d'orientation et de taille
    window.addEventListener('resize', updateBodyClasses);
    window.addEventListener('orientationchange', () => {
      setTimeout(updateBodyClasses, 100);
    });
  },
};
